import { contrastRatio } from '@yola/yola-palette-generator';
import highEmphasis from '../../rules/text/high-emphasis';
import utils from '../utils';

const { reduceColorPointByRatio, increaseColorPointByRatio } = utils;

const linkRuleLight = (params, { firstCondition, secondCondition }) => {
  const { targetColor, backgroundColor, targetColorPalette, whiteColor, blackColor } = params;
  const fallback = {
    rule: 'link.default.light',
    params,
  };
  let calculatedColor = increaseColorPointByRatio({
    targetColor,
    backgroundColor,
    targetColorPalette,
    condition: firstCondition,
    fallback,
  });

  if (secondCondition(contrastRatio(backgroundColor, calculatedColor))) {
    return calculatedColor;
  }

  calculatedColor = reduceColorPointByRatio({
    targetColor: calculatedColor,
    backgroundColor,
    targetColorPalette,
    condition: secondCondition,
    fallback,
  });

  const ratio = contrastRatio(backgroundColor, calculatedColor);

  if (firstCondition(ratio)) {
    return calculatedColor;
  }

  return highEmphasis({ backgroundColor, whiteColor, blackColor });
};

export default linkRuleLight;
